import * as wasm from './rust_wasm_attractor_bg.wasm';

const heap = new Array(32).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8Memory0;
function getUint8Memory0() {
    if (cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}
/**
*/
export class AttractorObj {

    static __wrap(ptr) {
        const obj = Object.create(AttractorObj.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_attractorobj_free(ptr);
    }
    /**
    * @param {number} w
    * @param {number} h
    * @param {number} px
    * @param {number} py
    * @param {number} pa
    * @param {number} pb
    * @param {number} pc
    * @param {number} pd
    * @returns {AttractorObj}
    */
    static new(w, h, px, py, pa, pb, pc, pd) {
        const ret = wasm.attractorobj_new(w, h, px, py, pa, pb, pc, pd);
        return AttractorObj.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    width() {
        const ret = wasm.attractorobj_width(this.ptr);
        return ret >>> 0;
    }
    /**
    * @returns {number}
    */
    height() {
        const ret = wasm.attractorobj_height(this.ptr);
        return ret >>> 0;
    }
    /**
    * @returns {number}
    */
    getn_maxed() {
        const ret = wasm.attractorobj_getn_maxed(this.ptr);
        return ret >>> 0;
    }
    /**
    * @returns {number}
    */
    getn_touched() {
        const ret = wasm.attractorobj_getn_touched(this.ptr);
        return ret >>> 0;
    }
    /**
    * @returns {number}
    */
    iters() {
        const ret = wasm.attractorobj_iters(this.ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} n
    */
    set_iters(n) {
        wasm.attractorobj_set_iters(this.ptr, n);
    }
    /**
    * @returns {number}
    */
    pixels() {
        const ret = wasm.attractorobj_pixels(this.ptr);
        return ret;
    }
    /**
    * @param {number} ms_budget
    * @param {boolean} first_frame
    * @param {number} n_first_frame
    * @returns {number}
    */
    calculate_frame(ms_budget, first_frame, n_first_frame) {
        const ret = wasm.attractorobj_calculate_frame(this.ptr, ms_budget, first_frame, n_first_frame);
        return ret;
    }
    /**
    * @returns {boolean}
    */
    free_pixels() {
        const ret = wasm.attractorobj_free_pixels(this.ptr);
        return ret !== 0;
    }
}
/**
*/
export class Point {

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_point_free(ptr);
    }
}
/**
*/
export class Rgba {

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rgba_free(ptr);
    }
}

export function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
};

export function __wbg_instanceof_Window_11e25482011fc506(arg0) {
    const ret = getObject(arg0) instanceof Window;
    return ret;
};

export function __wbg_performance_9d1ecf711183e1d5(arg0) {
    const ret = getObject(arg0).performance;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_now_44a034aa2e1d73dd(arg0) {
    const ret = getObject(arg0).now();
    return ret;
};

export function __wbg_call_ba36642bd901572b() { return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).call(getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbindgen_object_clone_ref(arg0) {
    const ret = getObject(arg0);
    return addHeapObject(ret);
};

export function __wbg_self_bb69a836a72ec6e9() { return handleError(function () {
    const ret = self.self;
    return addHeapObject(ret);
}, arguments) };

export function __wbg_window_3304fc4b414c9693() { return handleError(function () {
    const ret = window.window;
    return addHeapObject(ret);
}, arguments) };

export function __wbg_globalThis_e0d21cabc6630763() { return handleError(function () {
    const ret = globalThis.globalThis;
    return addHeapObject(ret);
}, arguments) };

export function __wbg_global_8463719227271676() { return handleError(function () {
    const ret = global.global;
    return addHeapObject(ret);
}, arguments) };

export function __wbindgen_is_undefined(arg0) {
    const ret = getObject(arg0) === undefined;
    return ret;
};

export function __wbg_newnoargs_9fdd8f3961dd1bee(arg0, arg1) {
    const ret = new Function(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

export function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);

